module.exports = __webpack_public_path__ + "img/home.fedebbc8.png";